import React, { ReactNode } from 'react';
import { Sidebar } from './Sidebar';
import { TopBar } from './TopBar';

interface LayoutProps {
  children: ReactNode;
}

export const Layout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <div style={{
      display: 'flex',
      minHeight: '100vh',
      backgroundColor: '#0f172a'
    }}>
      {/* Sidebar */}
      <Sidebar />

      {/* Main Content Area */}
      <div style={{
        marginLeft: '250px',
        width: 'calc(100% - 250px)',
        display: 'flex',
        flexDirection: 'column'
      }}>
        {/* Top Bar */}
        <TopBar />

        {/* Page Content */}
        <main style={{
          marginTop: '70px',
          padding: '30px',
          flex: 1,
          color: 'white',
          overflowY: 'auto'
        }}>
          {children}
        </main>
      </div>
    </div>
  );
};
